import { createGlobalStyle } from "styled-components";

import consoleConfig from "console_config";
import { semiBoldAlias } from "Libs/theme";
import { vendorPreviewTheme, vendorAssetTheme } from "Libs/themes";

const isOnStorybook = consoleConfig.STORYBOOK ?? false;

export const themeSetup = `
  :root {
  	--column-size: 110px;
	  --margin-between-columns: 32px;
  }

  @media only screen and (max-width: 1920px) {
    :root {
      --column-size: 110px;
    }
  }

  @media only screen and (max-width: 1440px) {
    :root {
      --column-size: 84px;
    }
  }

  @media only screen and (max-width: 1280px) {
    :root {
      --column-size: 71px;
    }
  }

  @media only screen and (max-width: 1024px) {
    :root {
      --column-size: 49px;
    }
  }

  @media only screen and (max-width: 940px) {
    :root {
      --column-size: 41px;
      --margin-between-columns: 16px;
    }
  }
  }
`;

export default createGlobalStyle`
  ${themeSetup};
  html, body, #app {
    margin: 0;
    font-family: 'Open Sans', Helvetica,Arial,sans-serif;
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: var(--section-color-neutral-300-background-color,var(--color-neutral-300));
    color: var(--section-night-color,var(--night));
    height: 100%;
  }

  #app {
    font-family: 'Open Sans', Helvetica,Arial,sans-serif;
  }

  #main {
    box-sizing: border-box;
  }

  h1, h5, h6 {
    font-weight: 400;
  }

  h2, h3 {
    font-weight: 700;
  }

  h4 {
    ${semiBoldAlias()};
  }

  pre,
  code {
    font-family: var(--ff-mono), monospace;
    font-size: 12px;
    font-variant: no-common-ligatures;
  }
  code {
    box-sizing: border-box;
    width: min-content;
    height: 20px;
    padding: 2px 4px;
    font-weight: 600;
    line-height: 20px;
    border-radius: 2px;
    color: var(--section-color-primary-800-color,var(--color-primary-800));
    background-color: var(--section-color-primary-100-background-color,var(--color-primary-100));
  }
  pre {
    background-color: var(--section-dark-background-color,var(--dark));
    color: var(--section-snow-color,var(--snow));
    border-radius: 2px;
    code {
      background-color: var(--section-ebony-background-color,var(--ebony));
      color: var(--section-snow-color,var(--snow));
    }
  }

  a {
    font-weight: 400;
    color: var(--link-color-primary-600-color,var(--theme-primary-700));
  }
  hr {
    background-color: var(--section-color-primary-100-background-color,var(--color-primary-100));
    box-shadow: none;
    height: 1px;
    border: none;
    margin: 16px 0;
    &.full-width {
      margin: 16px -32px;
    }
  }
  `;
